import { apiClient } from './client';

export interface ReferredUser {
  id: string;
  xrpl_address: string;
  username: string | null;
  avatar_url: string | null;
  created_at: string;
  first_level_earnings: number;
  second_level_earnings: number;
}

export interface ReferralData {
  referral_code: string;
  referral_link: string;
  referral_count: number;
  total_first_level_earnings: number;
  total_second_level_earnings: number;
  total_earnings: number;
  referred_users: ReferredUser[];
}

/**
 * Get current user's referral data
 */
export async function getReferrals(): Promise<ReferralData> {
  try {
    const response = await apiClient.get<ReferralData>('/referrals');
    return response;
  } catch (error) {
    console.error('Error fetching referrals:', error);
    throw error;
  }
}
